module.exports = __webpack_public_path__ + "static/media/26UNRWA11.fa7d692a.jpg";